/**
 * @module DiagnosisMenu
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Сайдбар на странице диагностики
 */
export default class DiagnosisMenu extends Component {
    static className = 'diagnosis-menu';
}
